/* SCROLL-LOCK — DONO UNICO da trava de rolagem do tema.

   ANTES DAQUI eram dois donos escrevendo document.body.style.overflow direto:
   cart.js (:75 tranca, :82 solta) e pdp-lightbox.js (:166 tranca, :179 solta).
   O acerto entre eles era assimetrico: o lightbox perguntava pelo carrinho antes
   de soltar (`cartOpen() ? 'hidden' : ''`), e o carrinho soltava sem perguntar
   por ninguem. Fechar o carrinho por cima de um lightbox aberto destravava a
   pagina embaixo dele, e o buraco era tapado por um MutationObserver no lightbox
   que reafirmava a trava sempre que a classe do carrinho mudava.

   Com dois donos isso ja era uma checagem par-a-par escrita na mao. Com o menu
   virando o terceiro seriam tres, e a que faltava era justamente a do carrinho.

   AQUI NAO HA PERGUNTA A NINGUEM. Ha uma lista de quem esta segurando: quem abre
   entra, quem fecha sai, e a trava so solta quando a lista esvazia. Nenhum dos
   componentes precisa saber que os outros existem, e acrescentar o quarto nao
   acrescenta checagem nenhuma.

   POR QUE DUAS TRAVAS E NAO UMA. As duas cobrem entradas diferentes:

     body.style.overflow  — a rolagem NATIVA. O <body> deste tema tem
                            overflow-x:hidden e o <html> nao declara overflow,
                            entao e o body que propaga para a viewport. Isso pega
                            teclado (espaco, PageDown, setas), barra de rolagem e
                            o arrasto do trackpad.

     lenis.stop()         — a rolagem PROGRAMATICA. O Lenis roda um RAF proprio
                            escrevendo scrollTop; overflow:hidden nao para uma
                            biblioteca que rola por conta. Ninguem nunca chamou
                            stop() neste tema, e por isso o fundo rolava atras do
                            carrinho ABERTO — defeito que ja existia, nao um que
                            o menu traria.

   O QUE CONTINUA ROLANDO. Lenis parado da preventDefault em wheel/touchmove,
   MENOS quando o caminho do evento passa por [data-lenis-prevent] — ali ele sai
   antes, sem preventDefault, e a rolagem nativa acontece dentro do elemento. E
   assim que .cart-lines, .pdp-lightbox__stage e .hmob__panel seguem rolando por
   dentro com a pagina morta atras. Um scroller novo que esqueca o atributo nao
   rola: e o preco de o Lenis ser um dono unico da roda, e esta escrito aqui para
   quem for criar o proximo.

   window.lenisInstance e lido A CADA CHAMADA, e nao guardado no load: o Lenis e
   construido em theme.js:312 depois deste arquivo, e nao e construido de jeito
   nenhum quando a lib nao carrega (theme.js:310 sai cedo). Ler na hora nao e
   defesa contra incerteza — e a unica hora em que a resposta e conhecida. */
(function () {
  'use strict';

  /* Array e nao Set: o tema alveja navegadores sem Set garantido e a lista tem
     tres nomes. indexOf aqui e mais barato que o polyfill. */
  var holders = [];

  /* A TRAVA MORA NO <html>, E NAO NO <body>. Ela morava no body ate a pagina
     ganhar overflow-x:clip na raiz, e essa mudanca a desligou em silencio.

     A regra de propagacao do CSS: o viewport herda o overflow do <body> APENAS
     enquanto o <html> for `visible` NOS DOIS EIXOS. Era o caso — o html so
     declarava text-size-adjust e scrollbar-gutter. Ao adicionar overflow-x:clip
     no html (para impedir a rolagem lateral que fazia o header parecer deslizar
     no toque), o html deixou de ser visible, o viewport passou a herdar DELE, e
     o `body{overflow:hidden}` daqui virou decoracao: continuava sendo escrito,
     continuava sem efeito. O menu abria e a pagina rolava por baixo.

     overflow-Y e nao overflow: escrever `overflow` cheio sobrescreveria o eixo X
     e devolveria a rolagem lateral. Escrevendo so o Y, o `clip` do CSS continua
     declarado no X.

     RESSALVA MEDIDA: com o Y em `hidden`, o Chrome computa o X como `hidden`
     tambem enquanto a trava esta ativa (medido: solto `clip`, travado `hidden`).
     Ou seja, durante a trava o eixo X vira contexto de rolagem em vez de so
     recortar. Na pratica nao muda nada porque nao ha mais transbordo horizontal
     — a causa dele foi tratada na fonte, no grid da media-fullbleed. Fica
     registrado porque, se algum transbordo novo aparecer, ele sera arrastavel
     exatamente enquanto um painel estiver aberto, que e o pior momento e o mais
     dificil de reproduzir.

     `clip` no Y nao serve como trava: sem scrollport a posicao de rolagem nao e
     preservada, e a pagina saltaria para o topo ao abrir o carrinho.

     Um alvo so, deterministico: enquanto o base.css declarar overflow-x:clip no
     html, o viewport herda do html. check-scrolllock.js amarra as duas pontas,
     para que remover o clip la nao volte a desligar a trava aqui em silencio. */
  function apply() {
    var locked = holders.length > 0;
    document.documentElement.style.overflowY = locked ? 'hidden' : '';
    var lenis = window.lenisInstance;
    if (!lenis) return;
    if (locked) lenis.stop();
    else lenis.start();
  }

  var api = {
    /* Idempotente de proposito: abrir duas vezes sem fechar nao cria duas
       entradas, senao o primeiro release deixaria a trava presa para sempre. */
    acquire: function (name) {
      if (holders.indexOf(name) !== -1) return;
      holders.push(name);
      apply();
    },
    release: function (name) {
      var i = holders.indexOf(name);
      if (i === -1) return;
      holders.splice(i, 1);
      apply();
    },
    /* quem segura agora — para depuracao no console e para os testes.
       Devolve COPIA: quem chamar nao pode remover um detentor pelas costas do
       apply() e deixar a pagina destravada com uma camada ainda aberta. */
    holders: function () { return holders.slice(); }
  };

  /* mesmo par de guardas do pdp-lightbox.js:41-42 — o node:test importa o
     modulo direto, o navegador o pendura no SXE. */
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined') {
    window.SXE = window.SXE || {};
    window.SXE.scrollLock = api;
  }
})();
